export const description =
  "La rénovation globale (≥ 2 sauts de classe DPE) dans le cadre MaPrimeRénov’ Accompagné : audit, bouquet de travaux, suivi par un Accompagnateur Rénov'. Conditions, aides cumulables 2026.";
